<template>
  <div class="legal-page">
    <Navigation />
    <PrivacyEn v-if="locale === 'en'" />
    <template v-else>
      <h1>Datenschutzerklärung</h1>
      
      <section class="legal-section">
        <h2>1. Datenschutz auf einen Blick</h2>
        
        <h3>Allgemeine Hinweise</h3>
        <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen oder unsere Services nutzen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
        
        <h3>Datenerfassung auf unserer Website</h3>
        <p><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong></p>
        <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt "Hinweis zur verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.</p>
        
        <p><strong>Wie erfassen wir Ihre Daten?</strong></p>
        <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in unsere KI-Automationen eingeben (Geburtsdatum, Geburtsort, Geburtszeit für Horoskop-Erstellungen).</p>
        
        <p><strong>Wofür nutzen wir Ihre Daten?</strong></p>
        <p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden oder zur Erstellung personalisierter Horoskope und spiritueller Beratungsinhalte.</p>
      </section>

      <section class="legal-section">
        <h2>2. Hosting</h2>
        <p>Wir hosten die Inhalte unserer Website über <strong>Vercel Inc.</strong>, 440 N Barranca Ave #4133, Covina, CA 91723, USA. Die Website wird über ein globales CDN bereitgestellt; Daten können in der EU und in den USA verarbeitet werden.</p>
        <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren und effizienten Bereitstellung). Bei Übermittlung in die USA stützen wir uns auf Standardvertragsklauseln der EU-Kommission.</p>
      </section>

      <section class="legal-section">
        <h2>3. Cookies und lokale Speicherung</h2>
        <p>Diese Website verwendet technisch notwendige Speicherung im lokalen Browser-Speicher (localStorage) für Theme-Einstellungen und Ihre Cookie-Einwilligung.</p>
        <p>Analyse-Tracking (SupportSrc / SP Pixel) wird nur nach Ihrer Einwilligung über unser Cookie-Banner aktiviert. Live-Chat (Pulse.is) und Newsletter-Formulare (SendPulse) werden ebenfalls nur nach Einwilligung in der Kategorie „Kommunikation & Formulare“ geladen.</p>
        <p>Sie können Ihre Einwilligung jederzeit widerrufen, indem Sie die Website-Daten in Ihrem Browser löschen oder die Cookie-Einstellungen erneut aufrufen.</p>
        <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) für Analyse-Tracking und Kommunikations-Tools; Art. 6 Abs. 1 lit. f DSGVO für technisch notwendige Speicherung.</p>
      </section>

      <section class="legal-section">
        <h2>4. Allgemeine Hinweise und Pflichtinformationen</h2>
        
        <h3>Datenschutz</h3>
        <p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>
        
        <h3>Hinweis zur verantwortlichen Stelle</h3>
        <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
        <p>
          Personal Coding LLC<br>
          Vertretungsberechtigt: Dawid Paliczuk<br>
          2125 Biscayne Blvd, Ste 204 #25212<br>
          33137 Miami, Florida, USA<br>
          Florida Division of Corporations, Dok.-Nr. L26000122441
        </p>
        <p>Operative Ansprechpartner für Datenschutzanfragen: Dawid Paliczuk (derzeit international tätig; Kontakt ausschließlich über die unten genannten Kanäle).</p>
        <p>
          Telefon: +49 176 22291967<br>
          E-Mail: dawid@personalcoding.de
        </p>

        <h3>Vertreter in der Union (Art. 27 DSGVO)</h3>
        <p>Personal Coding LLC ist nicht in der EU niedergelassen, verarbeitet jedoch personenbezogene Daten von Besuchern und Kunden aus der EU. Betroffene in der EU können uns direkt unter dawid@personalcoding.de kontaktieren. Wir prüfen die Benennung eines Vertreters in der Union gemäß Art. 27 DSGVO und veröffentlichen dessen Kontaktdaten hier, sobald ein Vertreter bestellt ist.</p>
        
        <h3>Speicherdauer</h3>
        <p>Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben.</p>
      </section>

      <section class="legal-section">
        <h2>5. Datenerfassung durch KI-Automationen</h2>
        
        <h3>Instagram-Automation für Horoskop-Erstellung</h3>
        <p>Wir bieten über Instagram eine automatisierte Lösung an, die personalisierte Horoskope erstellt. Dabei verarbeiten wir folgende Daten:</p>
        
        <h4>Art der Daten:</h4>
        <ul>
          <li>Geburtsdatum</li>
          <li>Geburtsort</li>
          <li>Geburtszeit</li>
          <li>Instagram-Benutzername (zur Kommunikation)</li>
        </ul>
        
        <h4>Zweck der Verarbeitung:</h4>
        <ul>
          <li>Erstellung personalisierter Horoskope (Text und Bild)</li>
          <li>Bereitstellung spiritueller Beratungsinhalte</li>
          <li>Kommunikation über Instagram Direct Messages</li>
        </ul>
        
        <h4>Rechtsgrundlage:</h4>
        <p>Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), die Sie durch die freiwillige Eingabe Ihrer Daten in die Automation erteilen.</p>
        
        <h4>Speicherort und -dauer:</h4>
        <p>Ihre Daten werden bei unseren Auftragsverarbeitern gespeichert, u. a. in der EU und den USA. Eine automatische Löschung erfolgt nicht. Sie können jederzeit die Löschung unter dawid@personalcoding.de beantragen.</p>
      </section>

      <section class="legal-section">
        <h2>6. Externe Dienstleister</h2>

        <h3>Pulse.is (Live-Chat)</h3>
        <p>Wir nutzen Pulse.is für den Live-Chat auf der Website. Das Chat-Widget wird erst nach Ihrer Einwilligung in der Cookie-Kategorie „Kommunikation & Formulare“ geladen. Dabei können technische Nutzungsdaten und Chat-Inhalte verarbeitet werden, wenn Sie den Chat nutzen.</p>
        <p><strong>Anbieter:</strong> Pulse.is (CDN: cdn.pulse.is)</p>
        <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung über das Cookie-Banner).</p>

        <h3>Reclaim.ai (Terminbuchung)</h3>
        <p>Für die Buchung von Beratungsterminen verlinken wir auf Reclaim.ai. Wenn Sie auf einen Buchungslink klicken, werden Sie auf die Website von Reclaim.ai weitergeleitet. Dort können personenbezogene Daten (z. B. Name, E-Mail, Terminwunsch) verarbeitet werden.</p>
        <p><strong>Anbieter:</strong> Reclaim.ai, Inc., USA</p>
        <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw. vorvertragliche Maßnahmen), sofern Sie einen Termin buchen; ansonsten Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter Terminvereinbarung).</p>
        <p>Weitere Informationen: <a href="https://reclaim.ai/privacy" target="_blank" rel="noopener">https://reclaim.ai/privacy</a></p>
        
        <h3>SendPulse (Automation-Platform & Newsletter)</h3>
        <p>Für Newsletter-Anmeldungen und die technische Bereitstellung unserer Automations-Services nutzen wir SendPulse. Das Newsletter-Formular-Script wird erst nach Ihrer Einwilligung in der Cookie-Kategorie „Kommunikation & Formulare“ geladen.</p>
        <p><strong>Anbieter:</strong> SendPulse LLC, 220 E 23rd St #401, New York, NY 10010, USA</p>
        
        <h4>Übertragene Daten:</h4>
        <ul>
          <li>Name und E-Mail-Adresse (Newsletter-Anmeldung)</li>
          <li>Ihre Eingaben in Automations-Services (Geburtsdaten etc.)</li>
          <li>Instagram-Kommunikationsdaten</li>
        </ul>
        
        <p>Newsletter: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Automations-Services: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung). Für Übermittlungen in die USA stützen wir uns auf Standardvertragsklauseln der EU-Kommission. Die Vereinbarung zur Datenverarbeitung (AVV/DPA) mit SendPulse ist Bestandteil der SendPulse-Nutzungsbedingungen und gilt ab Registrierung bzw. Nutzung des Kontos: <a href="https://sendpulse.com/de/legal/processing" target="_blank" rel="noopener">sendpulse.com/de/legal/processing</a></p>
        
        <h3>Instagram Business API (Meta)</h3>
        <p>Wir nutzen die Instagram Business API von Meta zur Kommunikation über Instagram Direct Messages. Instagram dient ausschließlich als Kommunikationskanal.</p>
        
        <h4>Verarbeitete Daten:</h4>
        <ul>
          <li>Instagram-Benutzername</li>
          <li>Nachrichten-Metadaten (Zeitstempel, etc.)</li>
        </ul>
        
        <p>Weitere Informationen finden Sie in den Datenschutzbestimmungen von Meta: <a href="https://www.facebook.com/privacy/policy" target="_blank">https://www.facebook.com/privacy/policy</a></p>
      </section>

      <section class="legal-section">
        <h2>7. Newsletter und Marketing</h2>
        
        <h3>Newsletter-Anmeldung (optional)</h3>
        <p>Auf Ihren ausdrücklichen Wunsch können wir Sie in Newsletter-Systeme eintragen. Dies erfolgt nur mit Ihrer expliziten Einwilligung.</p>
        
        <h4>Verarbeitete Daten:</h4>
        <ul>
          <li>E-Mail-Adresse</li>
          <li>Name (falls angegeben)</li>
          <li>Interessensgebiete (basierend auf Automation-Interaktionen)</li>
        </ul>
        
        <h4>Rechtsgrundlage:</h4>
        <p>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Sie können Ihre Einwilligung jederzeit widerrufen.</p>

        <h3>Messung des Nutzungsverhaltens (Website-Tracking)</h3>
        <p>Zur Optimierung unserer Website und Marketing-Maßnahmen erfassen wir Ereignisse zum Nutzungsverhalten. Hierfür setzen wir ein Tracking-Pixel (SupportSrc / SP Pixel) ein.</p>

        <h4>Erfasste Ereignisse (Beispiele):</h4>
        <ul>
          <li>Klicks auf zentrale Call-to-Action-Elemente (z. B. Terminbuchung)</li>
          <li>Interaktionen mit Formularen (z. B. Newsletter-Anmeldung)</li>
          <li>Nutzung einzelner Funktionen (z. B. Quiz-Interaktionen, Test-Buttons)</li>
          <li>Verweildauer auf der Website (Time-on-Site in Sekunden)</li>
          <li>Klicks auf rechtliche Links (z. B. Impressum)</li>
        </ul>

        <h4>Verarbeitete Daten:</h4>
        <ul>
          <li>Technische Nutzungsdaten (Zeitpunkt, aufgerufene Seite, Event-Typ)</li>
          <li>Pseudonyme Event-Parameter zur Auswertung der Nutzung</li>
          <li>Bei Newsletter-Events zusätzlich die angegebene E-Mail-Adresse</li>
        </ul>

        <h4>Zweck:</h4>
        <p>Analyse und Verbesserung der Website, Messung der Wirksamkeit von Inhalten und Marketing-Maßnahmen sowie Optimierung der Nutzerführung.</p>

        <h4>Rechtsgrundlage:</h4>
        <p>Die Verarbeitung erfolgt ausschließlich auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO, die Sie über unser Cookie-Banner erteilen. Ohne Einwilligung findet kein Tracking statt.</p>
      </section>

      <section class="legal-section">
        <h2>8. Datenweitergabe</h2>
        
        <h3>Weitergabe an Coaches und Partner</h3>
        <p>In bestimmten Fällen können Ihre Horoskop-Daten an qualifizierte Coaches oder Astrologen weitergegeben werden, dies erfolgt jedoch ausschließlich:</p>
        <ul>
          <li>Mit Ihrer ausdrücklichen vorherigen Zustimmung</li>
          <li>Für tiefergehende spirituelle Beratung</li>
          <li>Zur Qualitätsverbesserung unserer Services</li>
        </ul>
        
        <h3>Studien und Forschung</h3>
        <p>Anonymisierte Daten können für statistische Auswertungen und Studien verwendet werden. Eine Identifizierung Ihrer Person ist dabei nicht möglich. Dies erfolgt nur mit Ihrer separaten Einwilligung.</p>
      </section>

      <section class="legal-section">
        <h2>9. Ihre Rechte</h2>
        
        <p>Sie haben jederzeit das Recht:</p>
        <ul>
          <li><strong>Auskunft</strong> über Ihre bei uns gespeicherten personenbezogenen Daten und deren Verarbeitung (Art. 15 DSGVO)</li>
          <li><strong>Berichtigung</strong> unrichtiger personenbezogener Daten (Art. 16 DSGVO)</li>
          <li><strong>Löschung</strong> Ihrer bei uns gespeicherten personenbezogenen Daten (Art. 17 DSGVO)</li>
          <li><strong>Einschränkung der Verarbeitung</strong> Ihrer personenbezogenen Daten (Art. 18 DSGVO)</li>
          <li><strong>Widerspruch gegen die Verarbeitung</strong> Ihrer personenbezogenen Daten (Art. 21 DSGVO)</li>
          <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
        </ul>
        
        <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
        <p>Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</p>

        <h3>Löschung Ihrer Daten</h3>
        <p><strong>Newsletter:</strong> Abmelden über den Link in jeder Newsletter-E-Mail oder per E-Mail an dawid@personalcoding.de mit dem Betreff „Newsletter abmelden“.</p>
        <p><strong>Alle weiteren Daten:</strong> Löschersuchen richten Sie bitte an dawid@personalcoding.de mit dem Betreff „Datenschutz – Löschung“. Wir bearbeiten berechtigte Anfragen in der Regel innerhalb von 30 Tagen.</p>
        
        <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
        <p>Im Falle von Verstößen gegen die DSGVO steht Ihnen ein Beschwerderecht bei einer Aufsichtsbehörde zu – insbesondere in dem EU-Mitgliedstaat Ihres gewöhnlichen Aufenthalts, Ihres Arbeitsplatzes oder des Ortes des mutmaßlichen Verstoßes.</p>
        <p>Eine Übersicht der Datenschutzaufsichtsbehörden in der EU finden Sie beim Europäischen Datenschutzausschuss: <a href="https://edpb.europa.eu/about-edpb/about-edpb/members_de" target="_blank" rel="noopener">edpb.europa.eu</a></p>
      </section>

      <section class="legal-section">
        <h2>10. KI-Verordnung (EU AI Act)</h2>
        <p>Ab dem 2. August 2026 gelten Transparenzpflichten nach Art. 50 der Verordnung (EU) 2024/1689 (EU AI Act) für bestimmte KI-Systeme.</p>
        <p>Wenn Sie auf dieser Website mit unserem Live-Chat interagieren, werden Sie vor der ersten Nutzung darüber informiert, dass es sich um ein KI-gestütztes System handelt. Chat-Automationen (z. B. Instagram-, Telegram- oder WhatsApp-Bots) und KI-generierte Inhalte (z. B. Horoskop-Texte oder -Bilder) werden entsprechend gekennzeichnet.</p>
        <p>Ausführliche Informationen zu eingesetzten KI-Systemen, Ihrer Rolle als Betreiber (Deployer) bei B2B-Projekten und zu synthetischen Inhalten finden Sie auf unserer <a href="/ki-transparenz">KI-Transparenzseite</a>.</p>
      </section>

      <section class="legal-section">
        <h2>11. Kontakt</h2>
        <p>Bei Fragen zum Datenschutz, zur Ausübung Ihrer Rechte oder bei Beschwerden wenden Sie sich bitte an:</p>
        <p>
          <strong>Personal Coding LLC - Dawid Paliczuk</strong><br>
          E-Mail: dawid@personalcoding.de<br>
          Telefon: +49 176 22291967
        </p>
      </section>

      <section class="legal-section">
        <h2>12. Änderungen der Datenschutzerklärung</h2>
        <p>Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.</p>
        
        <p><strong>Stand:</strong> Juli 2026</p>
      </section>
    </template>

    <LegalFooter />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import PrivacyEn from './PrivacyEn.vue'
import LegalFooter from './LegalFooter.vue'
import Navigation from '../sections/Navigation.vue'

export default {
  name: 'LegalDatenschutz',
  components: { PrivacyEn, LegalFooter, Navigation },
  setup() {
    const { locale } = useI18n()
    return { locale }
  }
}
</script>

<style scoped>
.legal-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 120px 20px 0;
  color: #e2e8f0;
  line-height: 1.6;
  min-height: 100vh;
}

.legal-page :deep(h1) {
  font-size: 3rem;
  margin-bottom: 40px;
  color: #ffffff;
  text-align: center;
  font-weight: 700;
}

.legal-page :deep(.legal-section) {
  background: rgba(15, 16, 35, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
  margin-bottom: 30px;
}

.legal-page :deep(h2) {
  color: #ffffff;
  margin: 0 0 20px;
  font-size: 1.8rem;
  padding-bottom: 10px;
  border-bottom: 2px solid #00ffb3;
  font-weight: 600;
}

.legal-page :deep(h3) {
  color: #ffffff;
  margin: 25px 0 15px;
  font-size: 1.4rem;
  font-weight: 600;
}

.legal-page :deep(h4) {
  color: #ffffff;
  margin: 20px 0 10px;
  font-size: 1.2rem;
  font-weight: 600;
}

.legal-page :deep(p) {
  margin: 15px 0;
  color: #e2e8f0;
}

.legal-page :deep(strong) {
  color: #8b5cf6;
  font-weight: 600;
}

.legal-page :deep(ul),
.legal-page :deep(ol) {
  margin: 15px 0;
  padding-left: 30px;
}

.legal-page :deep(li) {
  margin: 8px 0;
  color: #e2e8f0;
}

.legal-page :deep(a) {
  color: #00ffb3;
  text-decoration: none;
}

.legal-page :deep(a:hover) {
  color: #ffffff;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .legal-page {
    padding: 100px 15px 0;
  }
  
  .legal-page :deep(h1) {
    font-size: 2.5rem;
  }
  
  .legal-page :deep(.legal-section) {
    padding: 20px;
  }
  
  .legal-page :deep(h2) {
    font-size: 1.5rem;
  }
  
  .legal-page :deep(h3) {
    font-size: 1.3rem;
  }
}
</style>
